import * as T from './types';

export function setSSR(value) {
  return {
    type: T.SET_SSR,
    payload: value,
  };
}
